<div class="space-y-4">
  <div class="flex items-start gap-2">
<!--    line-clamp-2 overflow-hidden text-ellipsis break-words-->
    <div class="max-w-sm font-['Roboto'] text-xl font-medium text-verde sm:text-[32px] leading-[1.1]">
      {{ productDetails.nombre }}
    </div>

    <div class="flex items-center space-x-[5px] mt-[2px]">
<!--      <ln-ln-fav-bg-beige-svg-icon-->
<!--        class="'w-7 h-7 cursor-pointer transition-transform duration-300 hover:scale-110"></ln-ln-fav-bg-beige-svg-icon>-->
      <button (click)="toggleShareBar()" class="group relative">
        <div class="font-['Roboto'] text-sm font-normal text-verde cursor-pointer">{{'buttons.share' | transloco}}</div>
        <span class="absolute right-0 top-2 hidden translate-x-8 group-hover:block">
          <ln-product-info-detail-share-bar [productName]="productDetails.nombre"></ln-product-info-detail-share-bar>
        </span>
      </button>
      <div class="group relative">
        <ln-share-svg-icon class="'w-[18px] h-[18px]  duration-300' cursor-pointer transition-transform hover:scale-125">
        </ln-share-svg-icon>
        <span class="absolute right-0 top-2 hidden translate-x-2 group-hover:block">
          <ln-product-info-detail-share-bar [productName]="productDetails.nombre"></ln-product-info-detail-share-bar>
        </span>
      </div>
    </div>
  </div>


    <p class="text-start font-['Roboto'] text-base font-bold text-rojizo">
      SKU: <span class="text-sm font-normal">{{ productDetails.productos[selectedVariant()].sku }}</span>
    </p>


  <p class="font-['Roboto'] text-base sm:text-lg font-normal text-cafe">{{'labels.designedBy' | transloco}}:
    <button (click)="navigateToArtisanProfile()" class="hover:scale-105">
      <span class="text-[16px] sm:text-lg font-medium">{{ productDetails.vendedor.nombre }}</span>
    </button>

  </p>

  <div class="flex flex-col border-t border-t-gris border-b border-b-gris pt-[18px] pb-[16px]">
    @if (piezaUnica()) {
      <div class="flex gap-1 font-['Roboto'] text-base font-normal text-cafe">
        <ln-info-bg-beige-svg-icon></ln-info-bg-beige-svg-icon>
        <p>
          {{'labels.productCreatedAsUnique' | transloco}} <span class="font-semibold">{{'labels.uniquePiece' | transloco}}</span>, {{'labels.askForSimilarPiece' | transloco}}.
        </p>
      </div>
    } @else {
      <div class="flex space-x-2">
        @if(productDetails.productos[selectedVariant()].precioOferta){
          <p class="font-['Roboto'] text-xl font-semibold text-cafe">
            <span class="line-through">{{ productDetails.productos[selectedVariant()].precio | priceFormat }}</span>
            <span class="font-['Roboto'] text-xs font-bold text-cafe"> USD</span>
          </p>
          <p class="font-['Roboto'] text-xl font-semibold text-rojizo">
            {{'labels.offer' | transloco}}
            {{ productDetails.productos[selectedVariant()].precioOferta | priceFormat }}
            <span class="font-['Roboto'] text-xs font-bold text-rojizo">USD</span>
          </p>
        } @else {
          <p class="font-['Roboto'] text-xl font-semibold text-cafe">
            <span>{{ productDetails.productos[selectedVariant()].precio | priceFormat }}</span>
            <span class="font-['Roboto'] text-xs font-bold text-cafe"> USD</span>
          </p>
        }

      </div>
    }
  </div>

  <div class="text-sm">
    @if(productDetails.vendedor.pdfInfoAtributo !== null && productDetails.vendedor.pdfInfoAtributo?.length) {
      <div class="border-b border-gris pb-4">
        <button (click)="guiaDeTallasClicked()" class="font-['Roboto'] text-base font-bold text-verde underline">{{'labels.sizeGuide' | transloco}}</button>
      </div>
    }

    @for (atributo of productDetails.productos[0].atributos; track atributo) {
      <div class="border-b border-gris py-2">
        <div class="flex flex-row items-center">
          <div class="font-['Roboto'] text-lg font-bold text-cafe w-[100px] pr-[16px]">
            {{ atributo.nombre }}:
          </div>
          <div class="font-['Roboto'] text-sm font-normal">
            <ln-dropdown [attributeName]="atributo.nombre" [products]="productDetails.productos" [selectedVariant]="selectedVariant"></ln-dropdown>
          </div>
        </div>

      </div>
    }
  </div>
  @if(productDetails.video360Url !== null || productDetails.vrUrl !== null || productDetails.arUrl !== null) {
  <div class="flex flex-col gap-2 border-b border-b-gris pb-4 text-xs sm:flex-row">
    @if(productDetails.video360Url !== null && productDetails.video360Url.length){
      <button
        (click)="vide360Clicked()"
        class="flex h-9 w-32 items-center rounded-[5px] border border-verde pl-[6px] hover:bg-gray-100">
        <ln-360-svg-icon></ln-360-svg-icon>
        <span class="ml-[10px] font-['Roboto'] text-sm font-normal text-cafe">{{'buttons.video360' | transloco}}</span>
      </button>
    }
    @if(productDetails.vrUrl !== null && productDetails.vrUrl.length){
    <button
      class="flex h-9 w-36 items-center rounded-[5px] border border-verde pl-[6px] hover:bg-gray-100"
      (click)="realidadVirtualClicked()">
      <ln-realidad-virtual-svg-icon class="h-7 w-7"></ln-realidad-virtual-svg-icon>
      <span class="font-['Roboto'] text-sm font-normal text-cafe">{{'buttons.virtualReality' | transloco}}</span>
    </button>
    }
    @if(productDetails.arUrl !== null && productDetails.arUrl.length){
    <button
      class="flex h-9 w-44 items-center rounded-[5px] border border-verde pl-[6px] hover:bg-gray-100"
      (click)="realidadAumentadaClicked()">
      <ln-realidad-aumentada-svg-icon class="h-5 w-5"></ln-realidad-aumentada-svg-icon>
      <div class="ml-[8px] font-['Roboto'] text-sm font-normal text-cafe">{{'buttons.augmentedReality' | transloco}}</div>
    </button>
    }
  </div>
  }
  <div class="h-12 w-80">
    <ln-primary-button [showSpinner]="showButonSpinner()" [label]="('labels.'+primaryButonText()) | transloco" [class]= "'flex w-full bg-[#577778] text-base font-semibold text-white/90 py-3 rounded-md justify-center '" (OnClick)="agregarAlCarritoClicket()"></ln-primary-button>
  </div>
</div>
